import { useState, useCallback } from "react";
const useConversationState = () => {
  const [conversationId, setConversationId] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("conversationId") || null;
  });
  const [sharedConversationId, setSharedConversationId] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("conversationId")) {
      return null;
    }
    return params.get("sharedConversationId") || null;
  });
  const [followUpQuestions, setFollowUpQuestions] = useState([]);
  const [conversationHistory, setConversationHistory] = useState([]);
  const [isActivelyStreaming, setIsActivelyStreaming] = useState(false);
  const [streamingAIResponse, setStreamingAIResponse] = useState("");
  const [searchAngleDetails, setSearchAngleDetails] = useState({});
  const [streamingStoreLocator, setStreamingStoreLocator] = useState(null);
  const [streamingDevInfo, setStreamingDevInfo] = useState(null);
  const [conversationPageContext, setConversationPageContext] = useState(null);
  const [isSharedView, setIsSharedView] = useState(false);
  const [sharedByUserName, setSharedByUserName] = useState(void 0);
  const [sharedAtMessageIndex, setSharedAtMessageIndex] = useState(void 0);
  const [sourceConversationId, setSourceConversationId] = useState(void 0);
  const [sourceCheckpointIndex, setSourceCheckpointIndex] = useState(void 0);
  const clearStreamingState = useCallback(() => {
    setStreamingAIResponse("");
    setStreamingStoreLocator(null);
    setStreamingDevInfo(null);
  }, []);
  return {
    conversationId,
    setConversationId,
    sharedConversationId,
    setSharedConversationId,
    conversationHistory,
    setConversationHistory,
    isActivelyStreaming,
    setIsActivelyStreaming,
    streamingAIResponse,
    setStreamingAIResponse,
    searchAngleDetails,
    setSearchAngleDetails,
    followUpQuestions,
    setFollowUpQuestions,
    streamingStoreLocator,
    setStreamingStoreLocator,
    streamingDevInfo,
    setStreamingDevInfo,
    clearStreamingState,
    conversationPageContext,
    setConversationPageContext,
    // Sharing state
    isSharedView,
    setIsSharedView,
    sharedByUserName,
    setSharedByUserName,
    sharedAtMessageIndex,
    setSharedAtMessageIndex,
    sourceConversationId,
    setSourceConversationId,
    sourceCheckpointIndex,
    setSourceCheckpointIndex
  };
};
export {
  useConversationState
};
//# sourceMappingURL=useConversationState.js.map
